<template>
    <div id="app">
        <vue-headful
                :title="$strings['menu.organization.name.1'] + ' ' + $strings['menu.organization.name.2']"
        />
        <div class="header">
            <Menu/>
        </div>
        <div class="main">
            <div class="router-content">
                <keep-alive>
                    <router-view/>
                </keep-alive>
            </div>
        </div>
        <!--        <div class="footer">-->
        <!--            <div style="width: 100%"><span>Contact: beavers<span style="display:none">spam</span>@e4bh3.com</span></div>-->
        <!--        </div>-->
    </div>
</template>

<script>

  export default {
    name: 'app',
    data() {
      return {
        activeIndex: this.$route.path,
      };
    },
    beforeMount: function() {
      if (window.localStorage.getItem("username")) {
        this.$auth.loggedIn = true;
        this.$auth.username = window.localStorage.getItem("username");
      }



      // window.googleMaps = new Promise(resolve => {
      //   window["initGoogleMaps"] = resolve;
      //   const googleMapsUrl = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAfYKb6xE0V8ic6Y98L09IdzgDc2ID7LL0&callback=initGoogleMaps&libraries=places";
      //   const googleMapsScript = document.createElement('SCRIPT');
      //   googleMapsScript.setAttribute('src', googleMapsUrl);
      //   googleMapsScript.setAttribute('async', '');
      //   googleMapsScript.setAttribute('defer', '');
      //   document.body.appendChild(googleMapsScript);
      // });


    }
  }
</script>

<style lang="scss">
    .header {
        align-self: center;
        flex-shrink: 0;
        max-width: 1048px;
        background-color: $beaverpurple;
        box-shadow: -15px 15px 20px rgba(0, 0, 0, 0.4);
        padding: 1.5em 1em;
        box-sizing: border-box;
        margin-top: 1em;
        border-radius: 1em;

        @media only screen and (max-width: 868px) {
            margin-top: 0;
            border-radius: 0;
        }
    }

    .router-content {
        flex-shrink: 0;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        height: 100%;
        margin: 0 auto;
        @media only screen and (max-width: 320px) {
           // padding : 0;
        }
        > div {
            width: 95%;
            max-width: 95%;
            margin: 1em 0 1em 0;
            border-radius: 1em;
            overflow: hidden;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
            @media only screen and (max-width: 868px) {
                border-radius: 0;
                margin: 0;
                width: 100%;
                max-width: 100%;
                overflow: hidden;
            }
        }
    }

    .main {
        flex: 1;
        overflow: auto;
        //Don't have scrollbar take up space on safari mobile - really only needed for 320px wide screens (SE) to get google maps to fit
        -webkit-overflow-scrolling: touch;
        display: flex;
    }

    html, body, #app {
        height: 100%;
        width: 100%;
        margin: 0;
    }

    ul, ol {
        padding: 0
    }

    #app {
        font-family: system-ui, -apple-system, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        //color: #2c3e50;
        display: flex;
        flex-direction: column;
        background: url('./assets/beaverbackground.png');
        background-size: cover ;
        background-position: center center;
        background-attachment: scroll;
    }

    /*.footer {
    height: $footer-height;
    flex-shrink: 0;
    text-align: center;

    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: center;
    align-content: center;
}

.footer > div {
    font-size: 14px;
}  */

    input {
        //-moz-outline-radius: 5px;
        //outline: solid 1px #dddfe2;
        //border-top: solid 1px #eeeeee;
        //padding-top: calc(.1667em + 4px);
        padding: 0.5em 0.75em;
        border-radius: 5px;
    }

    input::-moz-focus-inner /*Remove button padding in FF*/
    {
        border: 0;
        padding: 0;
    }

    button {
        color: unset;
        background-color: unset;
        border: unset;
        padding: unset;
    }


    .button {
        margin: 0 1em;
        color: $beaverpurple2;
        border: 1px solid $beaverpurple2;
        border-radius: 5px;
        width: 6em;
        height: 2em;
        line-height: 1;
        font-size: .9rem;
        //TODO: move
        font-family: system-ui, -apple-system, sans-serif;
        font-weight: 600;
        cursor: pointer;
    }

    .button-primary {
        @extend .button;
        background-color: $beaverpurple2;
        color: white;
    }

</style>
<style lang="scss">
    $font-size: 10px;
    @import "../node_modules/@ag-grid-community/core/dist/styles/ag-grid";
    @import "../node_modules/@ag-grid-community/core/dist/styles/ag-theme-material";
    @import "../node_modules/@ag-grid-community/core/dist/styles/ag-theme-balham";
    @import "../node_modules/@ag-grid-community/core/dist/styles/ag-theme-alpine";
    @import '../node_modules/vue-datetime/dist/vue-datetime.css';

    @import "../node_modules/normalize.css/normalize.css";


    .ag-theme-material {
        //clear, set with css in wrapper
        --ag-background-color: rgba(255,255,255,0.0);
        --ag-header-background-color: rgba(255,255,255,0.0);
    }
</style>
